/**
 * Branding configuration for the DevPulse monorepo
 *
 * This file contains the minimal configuration needed to customize
 * the monorepo for your organization. It is not exported from the package.
 *
 * Users should edit this file to point to their own repositories.
 */
/**
 * Application name displayed in the UI
 */
export const appName = "DevPulse";
/**
 * List of GitHub repository URLs to analyze
 *
 * Supported formats:
 * - https://github.com/owner/repo
 * - https://github.com/owner/repo.git
 * - git@github.com:owner/repo.git
 * - owner/repo
 */
export const repos = [
    "https://github.com/getdevpulse/monorepo",
    // Add more repositories here
    // "https://github.com/your-org/your-repo",
    // "git@github.com:your-org/another-repo.git",
    // "your-org/simple-format",
];
/**
 * OIDC authentication configuration (optional)
 *
 * Leave these empty to disable OIDC authentication.
 * When configured, users will be required to authenticate via OIDC.
 */
export const oidc = {
    /** OIDC authority URL (issuer endpoint) */
    authority: "",
    /** OIDC client ID from your identity provider */
    clientId: "",
    /** Redirect URI after successful authentication */
    redirectUri: "http://localhost:5173/callback",
    /** Redirect URI after logout */
    postLogoutRedirectUri: "http://localhost:5173",
    /** OAuth scopes to request (space-separated) */
    scope: "openid profile email",
};
/**
 * GitHub OAuth configuration (optional)
 *
 * Leave these empty to disable GitHub OAuth.
 * Alternative to OIDC for GitHub-based authentication.
 */
export const githubOAuth = {
    /** GitHub OAuth client ID */
    clientId: "",
    /** GitHub OAuth callback URI */
    redirectUri: "http://localhost:5173/auth/github/callback",
};
